import mergeConfig from '../merge-config';

const config = mergeConfig({});

export default config;
